module.exports = __webpack_public_path__ + "img/mfms02.0f018264.png";